import type { ServiceRequest } from "fhir/r4";
import { v4 as uuid } from "uuid";

import * as FHIRUtils from "../fhirutils";

export function buildServiceRequestForSDOHReferral(
  patientId: string,
  updatedBy: string
): ServiceRequest {
  const serviceReqeustId = uuid();

  const serviceRequest: ServiceRequest = {
    resourceType: "ServiceRequest",
    id: serviceReqeustId,
    status: "active",
    intent: "order",
    category: [
      {
        coding: [
          {
            system:
              "http://hl7.org/fhir/us/sdoh-clinicalcare/CodeSystem/SDOHCC-CodeSystemTemporaryCodes",
            code: "sdoh-category-unspecified",
            display: "SDOH Category Unspecified",
          },
        ],
      },
    ],
    code: {
      coding: [
        {
          system: "http://snomed.info/sct",
          code: "41920009",
          display: "Patient referral for socioeconomic factors",
        },
      ],
    },
    subject: {
      reference: "Patient/" + patientId,
    },
  };

  return FHIRUtils.addUpdatedBy(serviceRequest, updatedBy);
}

export function buildServiceRequestForFoodInsecurity(
  patientId: string,
  conditionId: string | undefined,
  updatedBy: string
): ServiceRequest {
  const serviceReqeustId = uuid();

  const serviceRequest: ServiceRequest = {
    resourceType: "ServiceRequest",
    id: serviceReqeustId,
    status: "active",
    intent: "order",
    category: [
      {
        coding: [
          {
            system:
              "http://hl7.org/fhir/us/sdoh-clinicalcare/CodeSystem/SDOHCC-CodeSystemTemporaryCodes",
            code: "food-insecurity",
            display: "Food Insecurity",
          },
        ],
      },
    ],
    code: {
      coding: [
        {
          system: "http://snomed.info/sct",
          code: "467771000124109",
          display: "Assistance with application for food pantry program",
        },
      ],
    },
    subject: {
      reference: "Patient/" + patientId,
    },
  };

  if (conditionId) {
    serviceRequest.reasonReference = [
      {
        reference: "Condition/" + conditionId,
      },
    ];
  }

  return FHIRUtils.addUpdatedBy(serviceRequest, updatedBy);
}
